import { BannerAlert } from './banner/banner-alert';
import { DialogueAlert } from './dialogue/dialogue-alert';
import { MutedAlert } from './muted/muted-alert';
import { ToastAlert } from './toast/toast-alert';
export const Alert = () => null;
Alert.Banner = BannerAlert;
Alert.Toast = ToastAlert;
Alert.Muted = MutedAlert;
Alert.Dialogue = DialogueAlert;
export { BannerAlertType } from './banner/banner-alert';
//# sourceMappingURL=index.js.map